import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Order, OrderInlineItem } from '../../../graphql/generated';

@Component({
  selector: 'pegasus-customer-cart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './customer-cart.component.html',
  styleUrl: './customer-cart.component.scss',
})
export class CustomerCartComponent {
  @Input() cart: Order;

  constructor() {}

  itemTotal(item: OrderInlineItem) {
    return (
      item.item_total +
      item.children.reduce((acc, child) => acc + child.item_total, 0)
    );
  }
}
